import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-cluster-node-presence-icon', {
    display: 'inline-block',
    height: '10px',
    width: '10px',
    borderRadius: '100%',
    /* error: '-o-border-radius': '100%', */
    /* error: '-moz-border-radius': '100%', */
    '-webkit-border-radius': '100%',
    /* error: '-khtml-border-radius': '100%', */
    marginRight: '6px',
});

cssRule('.tb-cluster-node-presence-icon.tb-remote-agent-presence-connected', {
    backgroundColor: applyColor(DesignTokens.color.feedback.default.success_light, '#2fa37d'),
});

cssRule('.tb-cluster-node-presence-icon.tb-remote-agent-presence-not-connected', {
    backgroundColor: applyColor(DesignTokens.color.feedback.default.error, '#a0131c'),
});

cssRule('.tb-cluster-node-presence-icon.tb-remote-agent-presence-warning', {
    backgroundColor: applyColor(DesignTokens.color.feedback.default.warning_light, '#eb8f50'),
});

cssRule('.tb-data-grid-cell-text-data-connect', {
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    lineHeight: '29px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});

cssRule('.tb-static-grid-table-cluster-pool-width', {
    width: '1210px',
});

cssRule('.tb-static-grid-table-shared-cluster-width', {
    width: '1210px',
});

